module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
// module id = wLXD
// module chunks = 0